// Modules
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

// Styled Components
import { LoadMoreBtn } from './load-more.styles';

// Actions
import { getNextSetOfEvents } from '../../store/reducers/event.reducer';

import { constant } from '../../constants/contant';
import { capitalizedLang } from '../../selectors/common.selector';

const LoadMore = () => {

	const lang = useSelector((state: any) => capitalizedLang()(state));
	const dispatch = useDispatch();

	return (
		<LoadMoreBtn
			label={constant[lang].VARIABLES.LOAD_MORE}
			onBiuOnClick={() => void dispatch(getNextSetOfEvents())}
		/>
	);
};

export default LoadMore;
